import {
  addStringNoLocale,
  getSourceUrl,
  addDatetime,
  saveSolidDatasetAt,
  setThing,
  createThing,
  addUrl,
} from "@inrupt/solid-client";
import { useSession } from "@inrupt/solid-ui-react";
import React, { useState } from "react";

import {
  CREATED_PREDICATE,
  QUOTE_CLASS,
  TEXT_PREDICATE,
  TYPE_PREDICATE,
} from "../../lib/predicates";

//TODO: Add optional author or source column for each quote

function AddQuote({ quoteList, setQuoteList }) {
  const { session } = useSession();
  const [quoteText, setQuoteText] = useState("");

  const addQuote = async (text) => {
    const indexUrl = getSourceUrl(quoteList);
    const quoteWithText = addStringNoLocale(
      createThing(),
      TEXT_PREDICATE,
      text
    );
    const quoteWithDate = addDatetime(
      quoteWithText,
      CREATED_PREDICATE,
      new Date()
    );
    const quoteWithType = addUrl(quoteWithDate, TYPE_PREDICATE, QUOTE_CLASS);
    const updatedQuoteList = setThing(quoteList, quoteWithType);
    const updatedDataset = await saveSolidDatasetAt(
      indexUrl,
      updatedQuoteList,
      {
        fetch: session.fetch,
      }
    );
    setQuoteList(updatedDataset);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    addQuote(quoteText);
    setQuoteText("");
  };
  const handleChange = (e) => {
    e.preventDefault();
    setQuoteText(e.target.value);
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="quote-form">
        <label htmlFor="quote-input">
          <input
            id="quote-input"
            type="text"
            value={quoteText}
            onChange={handleChange}
          />
        </label>
        <button type="submit" className="add-button">
          Add Quote
        </button>
      </form>
    </>
  );
}

export default AddQuote;
